import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { SeoTitle } from './SeoTitle'
import Canonical from './Canonical'
import StructuredData from './StructuredData'
import { SeoMetaDescription } from './SeoMetaDescription'

const MarketingLayout = () => {
    const location = useLocation();
    return (
        <div>
            <SeoTitle key={location.pathname} />
            <SeoMetaDescription key={location.pathname} />
            <Canonical key={location.pathname} />
            <StructuredData key={location.pathname}/>
            <main>
                <Outlet />
            </main>
        </div>
    )
}

export default MarketingLayout
